import { useState } from 'react';
import { useAuth } from '../auth';

export default function LoginPage() {
  const { login } = useAuth();
  // Variable kept named "email" for diff-friendliness, but accepts any
  // username string (e.g. 'sales', 'merissa') as well as full emails.
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    await new Promise(r => setTimeout(r, 400));
    const result = login(email, password);
    if (!result.ok) setError(result.error);
    setLoading(false);
  };

  return (
    <div className="page-center" style={{ background: 'var(--surface-warm)' }}>
      <div className="login-card">
        <div className="login-logo">
          <svg viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z"/></svg>
        </div>
        <h1 className="login-title">Soft Glow</h1>
        <p className="login-sub">Contract Portal — Sales Team Access</p>

        {error && (
          <div className="alert alert-error" style={{ marginBottom: '1.25rem' }}>
            <span className="alert-icon">⚠</span>
            <div className="alert-body"><p>{error}</p></div>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="field" style={{ marginBottom: '14px' }}>
            <label>Username or email</label>
            <input
              type="text"
              value={email}
              onChange={e => setEmail(e.target.value)}
              placeholder="e.g. sales or sales@softglowlab.com"
              required
              autoComplete="username"
            />
          </div>
          <div className="field" style={{ marginBottom: '1.5rem' }}>
            <label>Password</label>
            <input
              type="password"
              value={password}
              onChange={e => setPassword(e.target.value)}
              placeholder="Enter your password"
              required
              autoComplete="current-password"
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary btn-lg"
            style={{ width: '100%', justifyContent: 'center' }}
            disabled={loading}
          >
            {loading ? <><span className="spinner" />Signing in…</> : 'Sign in'}
          </button>
        </form>

        <div className="divider" />
        <p style={{ fontSize: '11px', color: 'var(--muted)', textAlign: 'center', lineHeight: 1.6 }}>
          Soft Glow Pte. Ltd. internal portal.
        </p>
      </div>
    </div>
  );
}
